import { useMutation, useQueryClient } from '@tanstack/react-query';
import { emailTemplateService } from '@/services/emailAdminService';
import type { EmailTemplate, EmailTemplateUpdateInput } from '@/types/emailAdmin';
import { queryKeys } from '@/lib/queryKeys';

export const useUpdateEmailTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation<EmailTemplate, unknown, EmailTemplateUpdateInput>({
    mutationFn: (input) => emailTemplateService.update(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.notifications.emailAdmin.templates(),
      });
    },
  });
};
